import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { truncateText } from "../utils/listPageUtils";

export const CELL_TEXT_MAX = 15;

export const toPlainText = (value) => {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
};

export default function TruncatedCell({
  value,
  max = CELL_TEXT_MAX,
  title,
  myanmar = false,
}) {
  const fullText = title ?? toPlainText(value);
  if (!fullText) return null;

  const displayText = truncateText(fullText, max);
  const isTruncated = fullText.length > max;
  const className = myanmar
    ? "data-list-truncated-cell data-list-truncated-cell--myanmar"
    : "data-list-truncated-cell";

  const content = (
    <span className={className} lang={myanmar ? "my" : undefined}>
      {displayText}
    </span>
  );

  if (!isTruncated) {
    return content;
  }

  return (
    <Tooltip title={fullText} arrow placement="top">
      {content}
    </Tooltip>
  );
}

export function TruncatedLink({ href, value, max = CELL_TEXT_MAX }) {
  const fullText = toPlainText(value ?? href);
  if (!fullText) return null;

  const displayText = truncateText(fullText, max);
  const isTruncated = fullText.length > max;

  const link = (
    <a
      className="data-list-link data-list-truncated-cell"
      href={href}
      target="_parent"
      rel="noreferrer"
    >
      {displayText}
    </a>
  );

  if (!isTruncated) {
    return link;
  }

  return (
    <Tooltip title={fullText} arrow placement="top">
      {link}
    </Tooltip>
  );
}
